export default __webpack_public_path__ + "26613dafdf9f53c401ac196b075d6ba5.png";